let seq = 0;
export const uid = (p: string) => `${p}_${++seq}`;
export const iso = (d: Date = new Date()) => d.toISOString();
